// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_SimulateInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payments/anticipations/simulate
 *
 * Simulates anticipation to preview fees and net value.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_SimulateInput {
subaccount_id: number
payment_id: string
installment_id?: string
}

registerContract('SubaccountsAnticipations_SimulateInput', {
  subaccount_id:  { type: 'number',  required: true },
  payment_id:     { type: 'string',  required: true },
  installment_id: { type: 'string',  required: false },
})
